import { useEffect, useState } from "react";
import { Card, Flex, Row, Col, Divider } from 'antd';
import { CheckCircleFilled, LoadingOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";



export const Disabled = (props) => {


    return (

        <div className="App">
    
          <Flex className='Main' justify='center' align='center'>
            <Card className='Login'
              bordered={false}
              style={{ width: 400 }}
            >
              <img alt="interlogica" src="https://www.interlogica.it/wp-content/uploads/2021/10/logo_interlogica_1.svg" />
              Metahuman Info
              <br></br>
              <br></br>
              Account Disabled
            </Card>
          </Flex>
    
        </div>
    
      );



}